var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M34.2069 1H1.7931C1.35689 1 1 1.36471 1 1.81047V26.1895C1 26.6353 1.35689 27 1.7931 27H34.2069C34.6431 27 35 26.6353 35 26.1895V1.81047C35 1.36471 34.6431 1 34.2069 1ZM19.5346 16.0424C19.1936 16.3909 18.686 16.5935 18.1388 16.5935C17.5836 16.5935 17.0681 16.3909 16.7271 16.0343L3.7679 2.62095H32.5731L19.5346 16.0424ZM12.4444 13.9108L2.58619 24.1309V3.69888L12.4444 13.9108ZM13.5626 15.0698L15.593 17.1771C16.2354 17.8335 17.1554 18.2145 18.1309 18.2145C19.0984 18.2145 20.0184 17.8416 20.6529 17.1852L22.5801 15.1995L32.3907 25.3791H3.60928L13.5626 15.0698ZM23.7063 14.0486L33.4138 4.06359V24.1309L23.7063 14.0486Z","fill":"#000F32","stroke":"#000F32"}));
}

Email.defaultProps = {"width":"36","height":"28","viewBox":"0 0 36 28","fill":"none"};

module.exports = Email;

Email.default = Email;
